/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    Challenge,
    ChallengeFromJSON,
    ChallengeFromJSONTyped,
    ChallengeToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Collection contains prize pools that can be won by users in a challenge
 * @export
 * @interface PrizePool
 */
export interface PrizePool {
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    quantity: number;
    /**
     * 
     * @type {Challenge}
     * @memberof PrizePool
     */
    challenge: Challenge;
    /**
     * Number of prizes that have been rewarded
     * @type {number}
     * @memberof PrizePool
     */
    quantityRewarded?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PrizePool
     */
    notifiedWinner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrizePool
     */
    winnerMessage?: string;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof PrizePool
     */
    rewardConfig?: RewardConfigResponse;
    /**
     * 
     * @type {string}
     * @memberof PrizePool
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    updatedAt: number;
}

export function PrizePoolFromJSON(json: any): PrizePool {
    return PrizePoolFromJSONTyped(json, false);
}

export function PrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizePool {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'challenge': ChallengeFromJSON(json['challenge']),
        'quantityRewarded': !exists(json, 'quantityRewarded') ? undefined : json['quantityRewarded'],
        'notifiedWinner': !exists(json, 'notifiedWinner') ? undefined : json['notifiedWinner'],
        'winnerMessage': !exists(json, 'winnerMessage') ? undefined : json['winnerMessage'],
        'rewardConfig': !exists(json, 'rewardConfig') ? undefined : RewardConfigResponseFromJSON(json['rewardConfig']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function PrizePoolToJSON(value?: PrizePool | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'challenge': ChallengeToJSON(value.challenge),
        'quantityRewarded': value.quantityRewarded,
        'notifiedWinner': value.notifiedWinner,
        'winnerMessage': value.winnerMessage,
        'rewardConfig': RewardConfigResponseToJSON(value.rewardConfig),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}


